import { type } from 'arktype';

import { CountryType } from '@/types/country';
import { FiatAccountType } from '@/types/fiatAccountType';

export const sendingFundsFlowModalSchema = type({
  country: type
    .valueOf(CountryType)
    .filter((c: CountryType): boolean => c !== CountryType.unset)
    .configure({ message: 'VALIDATION_REQUIRED' })
    .as<CountryType>(),
  accountType: type
    .valueOf(FiatAccountType)
    .filter((f: FiatAccountType): boolean => f !== FiatAccountType.unset)
    .configure({ message: 'VALIDATION_REQUIRED' })
    .as<FiatAccountType>(),
});
